import { render, staticRenderFns } from "./BatchTransferStudentDialog.vue?vue&type=template&id=01a1f884&"
import script from "./BatchTransferStudentDialog.vue?vue&type=script&lang=ts&"
export * from "./BatchTransferStudentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BatchTransferStudentDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports